function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationTruckRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 27a1 1 0 110-2 1 1 0 010 2zm0-19h-4v2h2.764l1 2H23v6h4.764l.236.473V25h-.184A2.99 2.99 0 0025 23a2.99 2.99 0 00-2.816 2H21v2h1.184A2.99 2.99 0 0025 29a2.99 2.99 0 002.816-2H28a2 2 0 002-2v-7L25 8zM17 25h-4.184A2.99 2.99 0 0010 23a2.99 2.99 0 00-2.816 2H5V6h12v19zm-7 2a1 1 0 110-2 1 1 0 010 2zm7-23H5c-1.1 0-2 .9-2 2v19c0 1.1.9 2 2 2h2.184A2.99 2.99 0 0010 29a2.99 2.99 0 002.816-2H19V6c0-1.1-.9-2-2-2z",
    fill: props.color
  }));
}

export default SvgIconTransportationTruckRexOutline;